import { useState, useEffect } from "react";
import apis from '../api';

const useParamsConfirmation = () => {
    const [paramsConfirmation, setParamsConfirmation] = useState([]);
    const headers = {
        authorization: localStorage.getItem('token')
    }
    let payload = {
        CLIENT: localStorage.getItem('client'),
        ENTITY: localStorage.getItem('entity'),
        OPTION: "2"
    }
    useEffect(() => {
        const getParams = async () => {
            if (localStorage.getItem('type') === "ADMIN") {
                let parametros = [];
                let lista = [];
                await apis.postConfirmation(payload, headers).then(res => {
                    parametros = res.data["SHEETS"]
                })
                parametros.forEach((element, index) => {
                    element["DETAIL"].forEach((row, i) => {
                        if (!(lista.some(l => l.TAG === row.LABEL))) {
                            lista.push({
                                VALUE: "", LABEL: row.NAME, OPTIONS: row.DETAIL, TAG: row.LABEL,
                                SHEET: element.NAME, SHEET_POSITION: [index], POSITION: i, TYPE: row.TYPE_NATIVE, REQUIRED: row.REQUIRED
                            })
                        }
                        else {
                            let pos = lista.findIndex(l => l.TAG === row.LABEL)
                            lista[pos].SHEET_POSITION.push(index);
                            lista[pos].LABEL = row.NAME;
                        }
                    })
                })
                setParamsConfirmation(lista)
            }
        }
        getParams()
    }, []);

    return [paramsConfirmation];
};

export default useParamsConfirmation;